import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { ordersRoutingModule } from './orders-routing.module';
import { ImportsPrimeModule } from 'src/app/_material/primeng.module';
import { SharedComponentsModule } from '../../shared/shared-components/shared-components.module';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { ordersComponent } from '../components/orders/orders.component';
import { AddordersComponent } from '../components/add-orders/add-orders.component';
import { draftOrdersComponent } from '../components/draft-order/draft-orders.component';
import { CreateTmsOrderComponent } from '../components/tms-order/create-tms-order/create-tms-order.component';
import { ViewTmsOrderComponent } from '../components/view-tms-order/view-tms-order.component';
import { ClickOutsideModule } from "ng-click-outside";
import { ViewBiddingComponent } from '../components/view-bidding/view-bidding.component';
import { TripOrderComponent } from '../components/trip-order/trip-order.component';
import { EndTripComponent } from '../components/end-trip/end-trip.component';


@NgModule({
  declarations: [
    ordersComponent,
    AddordersComponent,
    draftOrdersComponent,
    CreateTmsOrderComponent,
    ViewTmsOrderComponent,
    ViewBiddingComponent,
    TripOrderComponent,
    EndTripComponent
  ],
  imports: [
    CommonModule,
    ordersRoutingModule,
    FormsModule,
    ImportsPrimeModule,
    DatePipe,
    SharedModule,
    SharedComponentsModule,
    ClickOutsideModule
]
})
export class ordersModule { }
